export enum UserRoles {
  SUPER_ADMIN = 'SUPER_ADMIN',
  SISTER_COMPANY_ADMIN = 'SISTER_COMPANY_ADMIN',
  ADMIN = 'ADMIN',
  TECH = 'TECH',
  PRIMARY_CONTACT = 'PRIMARY_CONTACT',
  BUYER = 'BUYER',
  CUSTOMER = 'CUSTOMER',
  API = 'API',
}
